export default __webpack_public_path__ + "static/media/notif.aed4d691.svg";